import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

function removeHTMLTags(htmlString: string): string {
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, 'text/html')
  const textContent = doc.body.textContent || ''
  return textContent.trim()
}

/**
 * Validator that checks if rich text content is effectively empty.
 * PrimeNG Editor (Quill) often leaves behind empty HTML tags like <p><br></p>
 * when cleared, which standard Validators.required might not catch.
 */
export function richTextRequiredValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as string | null

    if (value === null || value === undefined) {
      return { required: true }
    }

    // Strip HTML tags and check if anything substantial remains
    const strippedValue = removeHTMLTags(value)

    // Quill might also represent an empty state with just a newline or multiple spaces
    if (strippedValue === '' || strippedValue === '\n' || strippedValue === '\r') {
      return { required: true }
    }

    return null
  }
}
